<template>
  <template v-if="index !== 'id'">
    <RegistrationCompensationTableAmountCellComponent
      v-if="typeof cell === 'object' && Object.values(cell).length"
      :index="index"
      :cell="cell"
    />
    <td v-else :aria-colindex="index" role="cell" :class="'cell__title ' + (active ? '-highlight' : '')">
      {{ cell }}
    </td>
  </template>
</template>

<script>
import RegistrationCompensationTableAmountCellComponent from "@/components/registration/quote/table/RegistrationCompensationTableAmountCellComponent.vue";
import { mapState } from "pinia";
import { useUserStore } from "@/store/user/user";
import { accessManager } from "@/services/security/access-manager";

export default {
  name: "RegistrationCompensationTableCellComponent",
  components: { RegistrationCompensationTableAmountCellComponent },
  props: {
    cell: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    displayEditButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    isEditable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(useUserStore, {
      permissions: (store) => store.permissions,
    }),
  },
  methods: {
    accessManager() {
      return accessManager;
    },
  },
};
</script>

<style lang="scss" scoped>
.cell {
  font-size: 15px;

  &__title {
    padding: 15px 10px;
    color: $black;
    &.-highlight {
      font-weight: 700;
      height: 50px;
    }
  }
}
</style>
